<template>
  <div class="wrapper">
    <div id="wrapper">
      <div id="main">
        <div id="header">
          <h1>
            <span class="icon">!</span>404<span class="sub">Not Found</span>
          </h1>
        </div>
        <div id="content">
          <h2>页面不存在</h2>
          <p>该页面不存在，请点击“返回”按钮回到首页!</p>
          <div class="text-right">
            <el-button @click="$router.replace('/')" type="primary"
              >返回</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const $router = useRouter()
</script>

<style scoped>
body {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}
@-webkit-keyframes main {
  0% {
    -webkit-transform: scale3d(0.1, 0.1, 1);
    opacity: 0;
  }
  45% {
    -webkit-transform: scale3d(1.07, 1.07, 1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale3d(0.95, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
  }
}
@-moz-keyframes main {
  0% {
    -moz-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  45% {
    -moz-transform: scale(1.07, 1.07);
    opacity: 1;
  }
  70% {
    -moz-transform: scale(0.95, 0.95);
  }
  100% {
    -moz-transform: scale(1, 1);
  }
}
@-webkit-keyframes logo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes footer {
  0% {
    top: 50px;
  }
  100% {
    top: 0;
  }
}
#wrapper {
  height: 100vh;
  background-image: linear-gradient(
    bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -o-linear-gradient(
    bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -moz-linear-gradient(
    bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -webkit-radial-gradient(
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -ms-linear-gradient(
    bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
}
#main {
  position: relative;
  width: 600px;
  margin: 0 auto;
  padding-top: 8%;
  animation: main 0.8s 1;
  animation-fill-mode: forwards;
}
#main #header h1 {
  position: relative;
  display: block;
  font: 72px Arial, sans-serif;
  color: #026872;
  text-shadow: 2px 2px #f7f7f7;
  text-align: center;
}
#main #header h1 span.sub {
  position: relative;
  font-size: 21px;
  top: -20px;
  padding: 0 10px;
  font-style: italic;
}
#main #header h1 span.icon {
  position: relative;
  display: inline-block;
  top: -6px;
  margin: 0 10px 5px 0;
  background: #026872;
  width: 50px;
  height: 50px;
  -moz-box-shadow: 1px 2px white;
  -webkit-box-shadow: 1px 2px white;
  box-shadow: 1px 2px white;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  color: #dfdfdf;
  font-size: 46px;
  line-height: 48px;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 0;
  vertical-align: middle;
}
#main #content {
  position: relative;
  width: 600px;
  background: white;
  -moz-box-shadow: 0 0 0 3px #ededed inset, 0 0 0 1px #a2a2a2,
    0 0 20px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0 0 0 3px #ededed inset, 0 0 0 1px #a2a2a2,
    0 0 20px rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 3px #ededed inset, 0 0 0 1px #a2a2a2,
    0 0 20px rgba(0, 0, 0, 0.15);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  z-index: 5;
  padding: 10px;
}
#main #content h2 {
  background-position: bottom;
  padding: 12px 0 22px 0;
  font: 20px 'TeXGyreScholaRegular', Arial, sans-serif;
  color: #8e8e8e;
  text-align: center;
}
#main #content p {
  position: relative;
  padding: 20px;
  font-size: 13px;
  line-height: 25px;
  color: #b5b5b5;
}
#main #content .utilities {
  padding: 20px;
}
</style>
